class CbLookbook extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-lookbook-track]');
    if (!this.track) return;

    this.slides = Array.from(this.track.querySelectorAll('[data-lookbook-slide]'));
    this.panels = Array.from(this.querySelectorAll('[data-lookbook-panel]'));
    this.current = this.querySelector('[data-lookbook-current]');
    this.index = 0;

    this.querySelector('[data-lookbook-prev]')?.addEventListener('click', () => this.go(-1));
    this.querySelector('[data-lookbook-next]')?.addEventListener('click', () => this.go(1));

    this.onScroll = this.onScroll.bind(this);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });

    this.sync();
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    clearTimeout(this.scrollTimer);
    this.scrollTimer = setTimeout(() => {
      const width = this.slides[0]?.offsetWidth || 1;
      const next = Math.round(this.track.scrollLeft / width);
      if (next !== this.index) {
        this.index = Math.max(0, Math.min(next, this.slides.length - 1));
        this.sync();
      }
    }, 80);
  }

  go(direction) {
    const total = this.slides.length;
    // Wrap around so the arrows never dead-end.
    this.index = (this.index + direction + total) % total;
    this.track.scrollTo({ left: this.index * (this.slides[0]?.offsetWidth || 0), behavior: 'smooth' });
    this.sync();
  }

  sync() {
    this.panels.forEach((panel, i) => {
      panel.hidden = i !== this.index;
    });

    if (this.current) {
      this.current.textContent = String(this.index + 1).padStart(2, '0');
    }
  }
}

if (!customElements.get('cb-lookbook')) {
  customElements.define('cb-lookbook', CbLookbook);
}
